import * as React from 'react';
import clsx from 'clsx';

interface Props {
  'data-testid'?: string;
}

const ReceiptCallout: React.FunctionComponent<Props> = ({
  'data-testid': dataTestId,
  children,
}) => {
  return (
    <div className={clsx('Receipt-lineItem', 'Receipt-callout')} data-testid={dataTestId}>
      {children}
    </div>
  );
};

export default ReceiptCallout;
